// Fire everything after DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  /** Helper so we don’t repeat ourselves */
  const initSlider = (selector, opts) => $(selector).slick(opts);

  /* ---------- 1st frame ---------- */
  requestAnimationFrame(() => {
    initSlider('.main-images', {
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1, infinite: true, dots: true } },
        { breakpoint: 600,  settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 402,  settings: { slidesToShow: 2, slidesToScroll: 2 } },
      ],
    });
  });

  /* ---------- 2nd frame ---------- */
  requestAnimationFrame(() => {
    initSlider('.slider-our-prod', {
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 4,
      slidesToScroll: 4,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 3, infinite: true, dots: true } },
        { breakpoint: 600,  settings: { slidesToShow: 2, slidesToScroll: 2 } },
        { breakpoint: 402,  settings: { slidesToShow: 2, slidesToScroll: 2 } },
      ],
    });
  });

  /* ---------- 3rd frame ---------- */
  requestAnimationFrame(() => {
    initSlider('.slider-custom-home-page', {
      dots: true,
      infinite: false,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 1, slidesToScroll: 1, infinite: true, dots: true } },
        { breakpoint: 600,  settings: { slidesToShow: 1, slidesToScroll: 1 } },
        { breakpoint: 402,  settings: { slidesToShow: 2, slidesToScroll: 2 } },
      ],
    });
  });



  /* Non-blocking DOM tweak (runs immediately) */
  $('.slide-custm-main-bannr')
    .addClass('zoom-in');
});


